module.exports = __webpack_public_path__ + "static/media/logo.59569bb5.svg";